<template>
	<div>
		<div class="treeTable">
			<!-- GERA MODAL PARA A TREEVIEW -->
			<b-modal
				ref="modalDetalhesaFluxo"
				size="lg"
				no-close-on-esc
				no-close-on-backdrop
				id="modal-detalhes-fluxoanalitico"
				:title="`Detalhes de fluxo de caixa ${modalDetalhes && modalDetalhes.nome ? '- '+modalDetalhes.nome : ''}`"
				tabindex="-1"
				>
				<template v-if="modalDetalhes && modalDetalhes.linhas" style="position:relative;"><!-- VERIFICO SE EXISTEM filhos -->
					<span class="premium-tag-s" style="right: 44px;top: -42px;">
						<i class="far fa-star"></i>&nbsp;
						<b>Premium</b>
					</span>
					<detalhe-fluxo-caixa :datas="modalDetalhes"></detalhe-fluxo-caixa>
				</template>
				<template v-if="modalDetalhes && !modalDetalhes.linhas" style="position:relative;">
					<span class="premium-tag-s" style="right: 44px;top: -42px;">
						<i class="far fa-star"></i>&nbsp;
						<b>Premium</b>
					</span>
					<detalhe-fluxo-caixa :datas="modalDetalhes"></detalhe-fluxo-caixa>
				</template>

				<template #modal-footer="{ hide }">
					<div class="float-right">
						<el-button size="small" @click="hide()">Fechar</el-button>
					</div>
				</template>

			</b-modal>
			
			<table class="table">
				<thead class="thead-dark">
					<tr>
						<th>
							<el-tooltip :content="!expandirTodos ? 'Expandir todos' : 'Recolher todos'" placement="top">
								<span class="expandir-todos" @click="clickExpandirRecolherTodos">
									<i class="fas" :class="!expandirTodos ? 'fa-plus' : 'fa-minus'"></i>
								</span>
							</el-tooltip>
							Nome
						</th>
						<th v-bind:key="i" v-for="(coluna,i) in treeDataSource.colunas" :class="`td${(i == 0 ? 1 : i)+1} text-center`">
							{{ coluna }}
						</th>
						<th :class="`text-center`">
							Total
						</th>
					</tr>
				</thead>
				<tbody>
					<tree-item
						v-for="(model,i) in treeDataSource.valores"
						:key="'root_node_flux'+i"
						:root="0"
						:num="i"
						@handlerExpand="handlerExpand"
						:nodes="treeDataSource.valores.length"
						:trees.sync="treeDataSource.valores"
						:datas.sync="treeDataSource.colunas"
						:model.sync="model">
					</tree-item>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import DetalheFluxoDeCaixa from '@/views/FluxoDeCaixa/DetalheFluxoDeCaixa'
export default {
	name: 'treeTable',
	props: ['list'],
	data() {
		return {
			treeDataSource: [],
			modalDetalhes: {},
			expandirTodos: false,
			activeNamesCollapse: [0]
		}
	},
	watch: {
		'list': {
			handler() {
				this.initTreeData()
				this.expandirTodos = false
			},
			deep: true
		}
	},
	methods: {
		initTreeData() { // ADD CONFIGURAÇÕES
			let tempData = JSON.parse(JSON.stringify(this.list))

			let reduceDataFunc = (data, level) => {
				if(!data){
					return false
				}
				data.map((m) => { // add opções a mais ao json
					//m.colunas = data.colunas
					m.isExpand = false
					m.children = m.linhas || []
					m.level = level
					m.Nivel = level
					m.bLeft = level === 1 ? 34 : (level - 2) * 16 + 34
					if (m.children && m.children.length > 0) {
						reduceDataFunc(m.children, level + 1)
					}
				})
			}
			reduceDataFunc(tempData.valores, 1)
			this.treeDataSource = tempData
		},
		handlerExpand(m) { // ABRIR/FECHAR FILHO
			this.$emit('handlerExpand', m)
			this.expandirTodos = false
		},
		changeColor(val, color) { // VERIFICA VERMELHO/VERDE/CINZA PELO VALOR
      let style = '';

      if (val < 0) {
          style = color ? 'color:#f18989' : 'border-color:#f18989';
      } else if (val == null || val === '') {
          style = color ? 'color:#a2a0a0' : 'border-color:#a2a0a0';
      } else {
          style = color ? 'color:#58ce5b' : 'border-color:#58ce5b';
      }

      return style;
    },
		toMoney(num){ // FORMATA REAL
			let n = num.valor ? num.valor : 0;
			return n ? Number(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' }) : 'R$ 0,00'
		},
		expandirRecolherTodos(data) {
      for (const item of data) {
          item.isExpand = this.expandirTodos;

          if (item.filhos) {
              this.expandirRecolherTodos(item.filhos);
          }
      }
    },
		clickExpandirRecolherTodos(){
			this.expandirTodos = !this.expandirTodos
			this.expandirRecolherTodos(this.treeDataSource.valores)
		}
	},
	components: {
		'detalhe-fluxo-caixa': DetalheFluxoDeCaixa,
		treeItem: () => import('./shared/TreeItem.vue') // importa o treeitem para gerar uma funcao recursiva
	},
	mounted() {
		const vm = this
		vm.$nextTick(() => {
			vm.initTreeData()
		})
		vm.$root.$on('modalDetalhesaFluxo', (dt) => {
			console.log('dt: ',dt)
			this.modalDetalhes = dt
		})

		this.initTreeData()
	}
}
</script>
<style>
	body.modal-open {
		overflow: hidden !important;
	}
</style>
